import { ScheduleBadge } from "./ScheduleBadge";
import { toRateOption } from "shared/ScheduleExecutionModalContent/cron/optionsRate";
import { useRequiredSessionWithUser } from "src/components/session/session";
import {
  useQueryAlert,
  useQuerySchedule,
} from "src/components/page-components/QueryPage/ScheduleQueryExecution/hooks";
import type { BadgeProps } from "src/components/ui-components/Badge/Badge";

interface Props {
  queryId: number;
  size: BadgeProps["size"];
}

export function QueryScheduleBadge(props: Props) {
  const { queryId, size } = props;
  const session = useRequiredSessionWithUser();
  const querySchedule = useQuerySchedule(session, queryId);
  const queryAlerts = useQueryAlert(session, querySchedule);

  const rateOption = querySchedule && toRateOption(querySchedule.cronString);

  const hasQueryAlerts = Boolean(
    queryAlerts?.email || queryAlerts?.slack || queryAlerts?.webhook
  );

  if (rateOption === undefined || querySchedule === undefined) {
    return null;
  }

  return (
    <ScheduleBadge
      size={size}
      schedule={querySchedule}
      hasQueryAlerts={hasQueryAlerts}
    />
  );
}
